<template>
<main id="work">
    <div class="grid" ref="grid">
        <div v-for="(item, index) in filteredItems" :key="index" class="item">
            <div class="item-content">
                <router-link :to="'/work/' + workFilter + '/' + item.slug" class="button" draggable="false">

                    <!-- Blank <componente>. Use ":is" to define which component to use -->
                    <component class="media" :is="getComponentName(item.media.type)" :data="item.media" @loaded="componentLoaded" />

                    <h2>
                        <span class="uppercase">{{item.client}}</span>
                        <br />
                        {{item.tags}}
                    </h2>
                </router-link>
            </div>
        </div>
        
        <!-- No results -->
        <div class="no-results" v-if="filteredItems.length === 0">
            <p>{{noResultMsg}}</p>
        </div>
    </div>
    
    
    <SecondaryNavigation 
        :text="'+ Filter by ' + ((activeFilterName !== 'All') ? activeFilterName : 'category')" 
        :showCloseIcon="false"
        :hasLink="true"
        @clicked="onToggleFilter"
    />
    

    <div id="filter" ref="filter">
        <div class="filter-overlay">
            <div class="close-overlay" ref="filterClose" @click="onToggleFilter"></div>
            
            <div class="overlay" ref="filterOverlay">
                <ul class="filters" ref="filterList">
                    <li v-for="filter in filters" :key="filter.slug" class="filter" :class="{'active' : filter.slug === activeFilterSlug}">
                        <a :href="'/work/' + filter.slug" @click="onSetFilter($event, filter)">{{filter.name}}</a>
                    </li>
                </ul>
                
                <div class="close-btn" @click="onToggleFilter">
                    <span class="bar-1"></span>
                    <span class="bar-2"></span>
                </div>
            </div>
        </div>
    </div>

</main>
</template>


<script>
import axios from 'axios'
import Size from '@/plugins/WindowSize'
import Scroll from '@/plugins/WindowScroll'
import SecondaryNavigation from '@/components/SecondaryNavigation'

// Media Components
import MediaImage from '@/components/MediaImage'
import MediaVideo from '@/components/MediaVideo'
import MediaCarousel from '@/components/MediaCarousel'


export default {
    components: {
        SecondaryNavigation,
        MediaImage,
        MediaVideo,
        MediaCarousel,
    },

    props: {
        workFilter: String,
    },

    data: function() {
        return {
            loading: false,
            filters: [],
            items: [],
            pageTotal: 0,
            itemsPerPage: 0,
            pageCurrent: 0,
            isLastPage: false,
            isFilterOpen: false,
            gridNodes: [],
            activeFilterSlug: 'all',
            activeFilterName: 'All',
            noResultMsg: '',
            componentsLoaded: 0
        };
    },
    
    created() {
        Size.addListener(this.onResize)
        Scroll.addListener(this.onScroll)
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
        Scroll.removeListener(this.onScroll)
        
    },

    mounted() {
        this.getData()
    },


    methods: {
        getData(more) {
            if (this.isLastPage || this.loading) {
                return
            }

            let filter = this.workFilter || ""
            let page = this.pageCurrent + 1
            let url = "/data/work-" + page + ".json" + (filter ? "?filter=" + filter : "")

            this.loading = true

            return axios.get(url)
                .then(res => {
                    this.pageCurrent = res.data.pageCurrent
                    if (!more) {
                        this.pageTotal = res.data.pageTotal
                        this.itemsPerPage = res.data.itemsPerPage
                        this.filters = res.data.filters
                        this.items = res.data.works
                        
                    } else {
                        this.items = this.items.concat(res.data.works)
                    }
                    
                    this.isLastPage = this.pageCurrent == this.pageTotal
                    this.noResultMsg = 'No results found'
                    
                    
                    // Set active filter
                    if (this.workFilter !== 'all') {
                        for (var i = 0; i < this.filters.length; i++) {
                            if (this.workFilter === this.filters[i].slug) {
                                this.activeFilterSlug = this.filters[i].slug
                                this.activeFilterName = this.filters[i].name
                            }
                    
                        }
                    }
                    
                    
                    this.$emit('loaded') // Tell App data is ready
                    
                    this.$nextTick(() => {
                        this.prepareGrid()
                        this.resizeGrid()
                        this.onScroll();
                        this.loading = false
                    })
                })
                .catch(error => {
                    throw new Error('Data Failed: ', error)
                })
        },


        prepareGrid() {
            
            // CSS Grid Masonry
            // https://medium.com/@andybarefoot/a-masonry-style-layout-using-css-grid-8c663d355ebb
            // this.gridRowHeight = parseInt(
            //     window
            //     .getComputedStyle(this.$refs.grid)
            //     .getPropertyValue("grid-auto-rows")
            // )
            // this.gridRowGap = parseInt(
            //     window
            //     .getComputedStyle(this.$refs.grid)
            //     .getPropertyValue("grid-row-gap")
            // )
            
            this.gridNodes = this.$refs.grid.querySelectorAll('.item')

            // Store node referense
            for (let i = 0; i < this.gridNodes.length; i++) {
                this.gridNodes[i].node = this.gridNodes[i].querySelector(".item-content")
            }

            // // Content is not filling up entire viewport, load more data
            // if (document.body.scrollHeight < Size.height) {
            //     this.getData("more")
            // }
        },


        onSetFilter(event, filter) {
            event.preventDefault()
            
            this.onToggleFilter()
            this.activeFilterSlug = filter.slug
            this.activeFilterName = filter.name


            // Fade in/out grid - while updating filter
            TweenLite.to(this.$refs.grid, 0.4, {opacity: 0, onComplete: () => {
                this.$router.push({ path: '/work/'+filter.slug })
                
                TweenLite.to(this.$refs.grid, 0.4, {delay: 0.6, opacity: 1})
            }})
            
            
            // // Set currentFilterName
            // if (this.workFilter !== 'all') {
            //     for (var i = 0; i < this.filters.length; i++) {
            //         if (this.workFilter === this.filters[i].slug) {
            //             this.currentFilterName = this.filters[i].name
            //         }
            // 
            //     }
            // }
        },
        
        onToggleFilter() {
            this.isFilterOpen = !this.isFilterOpen
        
            // OPEN / CLOSE
            if (this.isFilterOpen === true) {
                this.onOpenFilter()
            } else {
                this.onCloseFilter()
            }
        },

        onOpenFilter() {
            TweenLite.set(this.$refs.filterClose, {autoAlpha: 1});
            TweenLite.to(this.$refs.filterOverlay, 0.4, {x: '0%', ease: Power4.easeOut});
            TweenLite.to(this.$refs.filterList, 0.2, {delay:0.4, opacity: 1});
            
            
            // TweenLite.to(this.$refs.filterCta, 0.2, {y: '101%', ease: Power4.easeInOut});
            
            this.isFilterOpen = true
        },
        
        onCloseFilter() {
            TweenLite.set(this.$refs.filterClose, {autoAlpha: 0});
            TweenLite.to(this.$refs.filterList, 0.2, {opacity: 0});
            TweenLite.to(this.$refs.filterOverlay, 0.4, {delay:0.2, x: '101%', ease: Power4.easeInOut});
            
            // TweenLite.to(this.$refs.filterCta, 0.2, {delay:0.4, y: '0%', ease: Power4.easeInOut});
            
            this.isFilterOpen = false
        },

        getComponentName(type) {
            // Components are: MediaImage, MediaVideo, MediaCarousel, MediaColumnLayout, MediaEmbedVideo
            var camelCased = type.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
            var name = camelCased.charAt(0).toUpperCase() + camelCased.slice(1) // Uppsercase first letter
            return name
        },

        componentLoaded() {
            this.componentsLoaded++
            if (this.componentsLoaded === this.filteredItems.length) {
                // this.$emit('allComponentsLoaded')
            }
        },

        reachingPageBottom(offset) {
            return (
                Scroll.y + Size.height >= document.body.scrollHeight - (offset || 0)
            )
        },

        onScroll() {
            
            if (this.reachingPageBottom(Size.height / 2)) {
                this.getData("more")
            }
        },

        onResize() {
            this.resizeGrid()
        },

        resizeGrid() {
            for (let i = 0; i < this.gridNodes.length; i++) {
                this.resizeGridItem(this.gridNodes[i])
            }
        },

        resizeGridItem(item) {
            
            var height = item.node.offsetHeight
            var rowHeight = (window.innerWidth < 1024) ? 10 : (window.innerWidth < 1440) ? 20 : 30;
            var rowSpan = Math.ceil(
                // (height + this.gridRowGap) / (this.gridRowHeight + this.gridRowGap)
                height / rowHeight
            )
            
            item.style.gridRowEnd = "span " + (rowSpan + 2)
        }

    },

    computed: {
        filteredItems: function() {

            return this.items.filter((item) => {

                if (this.workFilter === 'all') {
                    return true
                }

                var tags = item.tags.split(', ');
                return tags.find((tag) => {
                    let kebabTag = tag.replace(/\s+/g, '-').toLowerCase() // kebab-case
                    return kebabTag === this.workFilter
                })
            })
        },
        

        // selectedFilterName: function() {
        //     return this.workFilter.replace(/-/g, ' ') // remove dashes, add spaces
        // }
    },

    watch: {
        workFilter() {
            this.pageCurrent = 0
            this.isLastPage = false
            this.getData()
        }
    }
};
</script>

<style lang="scss">
// scoped

@import "../scss/variables";
@import "../scss/font-scaling";

// body {
//     overflow: hidden;
// }
body.block-scroll {
    overflow: hidden;
}

#work {
    @include page-padding;
    
    @media (min-width: $tablet) {
        padding-top: 40px;
    }

    #filter {
        .filter-overlay {
            // width: 100%;
            font-size: 20px; // define font-size on parent so children can use em
            @media (min-width: $tablet) {
                // @include FluidFontStart(1024, 1600, 24, 32);
                // @include FluidFontEndless(1600, 32, 0.4);
                @include FluidFontStart(1024, 1600, 20, 28);
                @include FluidFontEndless(1600, 28, .4);
            }
            
            .overlay {
                position: fixed;
                background: rgba(0, 0, 0, 0.9);
                width: 100%;
                top: 0;
                left: 0;
                height: 100vh;
                padding: 2em 1.5em;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                
                transform: translateX(101%); // Hidden from start
                
                @media (min-width: $tablet) {
                    padding: calc(50px - 0.3em) 3%;
                    width: calc(33.333% + (16.666% - 1.5%));
                    left: calc(66.666% - (16.666% - 1.5%)); // 2/3 of grid - (half column width - half grid gap)
                    
                }
                
                
                .filters {
                    opacity: 0; // Hidden from start
                    
                    .filter {
                        position: relative;
                        margin-bottom: 0.5em;
                        
                        &:first-child {
                            margin-bottom: 1.5em;
                        }
                        
                        &.active {
                            a {
                                opacity: 1;
                                &:before {
                                    background-color: #fff;
                                }
                            }
                        }
                        
                        // Link
                        a {
                            color: #fff;
                            margin-left: 2em;
                            display: inline-block;
                            opacity: 0.3;
                            &:hover {
                                // text-decoration: line-through;
                                opacity: 1;
                                // &:before {
                                //     border: 1px solid rgba(255, 255, 255, 1);
                                // }
                            }
                            
                            // Check box
                            &:before {
                                content: '';
                                width: 0.7em;
                                height: 0.7em;
                                position: absolute;
                                top: 0.3em;
                                left: 0;
                                border: 1px solid #fff; //rgba(255, 255, 255, 0.3);
                                border-radius: 50%;
                               
                            }
                        }
                    }
                }
                
                .close-btn {
                    position: absolute;
                    
                    right: 20px;
                    top: 20px;
                    width: 20px;
                    height: 20px;
                    
                    @media (min-width: $tablet) {
                        top: calc(40px - 4px); // Optical adjustment
                        right: calc(94px/2);
                        transform: translateX(50%);
                        cursor: pointer;
                    }
                    
                    .bar-1,
                    .bar-2 {
                        position: absolute;
                        height: 1px;
                        left: 0;
                        width: 100%;
                        top: 50%;
                        background: #fff;
                    }
                    
                    .bar-1 {
                        transform: rotate(45deg);
                    }
                    .bar-2 {
                        transform: rotate(-45deg);
                    }
                }
            }
            
            .close-overlay {
                position: fixed;
                background: rgba(255, 255, 255, 0);
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                
                // Hidden from start
                opacity: 0;
                visibility: hidden;
            }
        }
        
    }

    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 0 14px;
        grid-auto-rows: 10px;
        
        @media (min-width: $tablet) {
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 0 20px;
            grid-auto-rows: 20px;
        }
        
        @media (min-width: $large-desktop) {
            grid-auto-rows: 30px;
        }
        

        .item {
            color: #000;
            
            .item-content {

                &:hover {
                    a {
                        text-decoration: underline;
                    }
                    .media {
                        .image-container,
                        .slides,
                        .video-container {
                            transition: 10s transform linear;
                            transform: scale(1.2);
                        }
                    }
                }

                a {
                    text-decoration: none;
                }
                h2 {
                    
                    
                    // font-weight: 400;
                    // font-size: 11px;
                    
                    // @media (min-width: $tablet) {
                    //     @include FluidFontStart(1024, 1600, 12, 16);
                    //     @include FluidFontEndless(1600, 16, 0.4);
                    //     margin-top: 3%;
                    // }
                    
                    font-size: 13px;
                    line-height: 1.4em;
                    font-weight: 400;
                    
                    @media (min-width: $tablet) {
                        font-size: 15px;
                        margin-top: 0.6em;
                    }
                    
                    @media (min-width: $large-desktop) {
                        line-height: 1.46em;
                        @include FluidFontStart(1440, 2800, 15, 23);
                    }
                    
                    
                    .uppercase {
                        text-transform: uppercase;        
                    }
                    
                    .year {
                        position: relative;
                        font-size: 0.5em;
                        top: -0.7em;
                    }
                }

                .media {
                    overflow: hidden;

                    .image-container,
                    .slides,
                    .video-container {
                        transition: 0.6s transform linear;
                    }

                }
            }
        }
        
        .no-results {
            font-size: 11px;
            text-transform: uppercase;
            color: #000;
            font-weight: 400;
            text-decoration: none;

            @media (min-width: $tablet) {
                @include FluidFontStart(1025, 1600, 12, 16);
                @include FluidFontEndless(1600, 16, 0.4);
            }
        }
    }
}
</style>
